/**
 * @generated SignedSource<<fc264a27600efdad05b3a85b8dba6877>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entitiesFilter"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "entitiesFilter",
            "variableName": "entitiesFilter"
        },
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
            (v2 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unit",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ScheduleTemplateInformationResourceScheduleTimesQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "ScheduleTimesPayload",
                    "kind": "LinkedField",
                    "name": "scheduleTemplateTimes",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ScheduleTimesPayload_iHaveScheduleTimes"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ScheduleTemplateInformationResourceScheduleTimesQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "ScheduleTimesPayload",
                    "kind": "LinkedField",
                    "name": "scheduleTemplateTimes",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleTimeByEntityAndAssignmentType",
                                    "kind": "LinkedField",
                                    "name": "timesByEntityAndAssignmentType",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CalculateTimePartsPayload",
                                            "kind": "LinkedField",
                                            "name": "calculatedTimes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "employmentSummaries",
                                                    "args": null,
                                                    "concreteType": "CalculateTimePartsSummaryByEmployment",
                                                    "kind": "LinkedField",
                                                    "name": "summaryByEmployment",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Employment",
                                                            "kind": "LinkedField",
                                                            "name": "employment",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EmploymentSetting",
                                                                    "kind": "LinkedField",
                                                                    "name": "employmentSetting",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "title",
                                                                            "storageKey": null
                                                                        },
                                                                        (v2 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v2 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": "eventSummaries",
                                                            "args": null,
                                                            "concreteType": "TimePartsSummary",
                                                            "kind": "LinkedField",
                                                            "name": "calculatedSummary",
                                                            "plural": true,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "isWork",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "TimeSpecificationPartSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "nonRegularPartsSummary",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v3 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "unit",
                                                                                    "value": "SECOND"
                                                                                }
                                                                            ],
                                                                            "concreteType": "TimeSpanUnitValue",
                                                                            "kind": "LinkedField",
                                                                            "name": "duration",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v4 /*: any*/),
                                                                                (v5 /*: any*/)
                                                                            ],
                                                                            "storageKey": "duration(unit:\"SECOND\")"
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v5 /*: any*/),
                                                                (v4 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "IHaveScheduleTimes",
                            "abstractKey": "__isIHaveScheduleTimes"
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "acdecfa8e688c970a393055f54f3ba7b",
            "id": null,
            "metadata": {},
            "name": "ScheduleTemplateInformationResourceScheduleTimesQuery",
            "operationKind": "query",
            "text": "query ScheduleTemplateInformationResourceScheduleTimesQuery(\n  $entitiesFilter: ScheduleTemplateShiftFilterRequestInput\n  $model: PublishScheduleTemplateRequestInput!\n) {\n  scheduleTemplateTimes(entitiesFilter: $entitiesFilter, model: $model) {\n    ...ScheduleTimesPayload_iHaveScheduleTimes\n  }\n}\n\nfragment ScheduleTimesPayload_iHaveScheduleTimes on IHaveScheduleTimes {\n  __isIHaveScheduleTimes: __typename\n  timesByEntityAndAssignmentType {\n    calculatedTimes {\n      employmentSummaries: summaryByEmployment {\n        employment {\n          employmentSetting {\n            title\n            id\n          }\n          id\n        }\n        eventSummaries: calculatedSummary {\n          event {\n            id\n            name\n          }\n          isWork\n          nonRegularPartsSummary {\n            event {\n              id\n              name\n            }\n            duration(unit: SECOND) {\n              value\n              unit\n            }\n          }\n          unit\n          value\n        }\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "55736e7206b65a7767994accc2dbb080";
export default node;
